<template>
    <div class="role_dialog">
        <el-dialog
                :title="title"
                :before-close="cancelButton"
                :visible.sync="dialogVisible"
                max-width="70%"
        >
            <el-form
                    :model="ruleForm"
                    :rules="rules"
                    ref="ruleForm"
                    label-width="100px"
                    class="demo-ruleForm"
            >
                <el-form-item label="Role Name:" prop="roleName">
                    <el-input
                            v-model="ruleForm.roleName"
                            auto-complete="off"
                            placeholder="Please enter Role Name"
                            @blur="rolenameBlur"
                    ></el-input>
                </el-form-item>
                <el-form-item label="roleDesc:" prop="roleDesc">
                    <el-input
                            type="textarea"
                            v-model="ruleForm.roleDesc"
                            auto-complete="off"
                            placeholder="Please enter a roleDesc"
                    ></el-input>
                </el-form-item>
                <el-form-item label="Role status:" prop="status">
                    <el-radio v-model="ruleForm.status" label="1">On</el-radio>
                    <el-radio v-model="ruleForm.status" label="0">Off</el-radio>
                </el-form-item>
                <el-form-item label="Permission list:" prop>
                    <div class="permission">
                        <el-tree
                                :data="data"
                                show-checkbox
                                node-key="id"
                                default-expand-all
                                :props="defaultProps"
                                ref="tree"
                                :default-checked-keys="defaultArray"
                        ></el-tree>
                    </div>
                </el-form-item>
                <el-form-item class="button">
                    <el-button type="primary" @click="submitForm('ruleForm')">Submit</el-button>
                    <el-button @click="resetForm('ruleForm')">Cancel</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
    import {permissionTree, repeatRole} from "@/common/js/http/version3Api.js";

    export default {
        props: [
            "passVisible",
            "title",
            "editMessage",
            "selectValue",
            "inputValue",
            "editId"
        ],
        name: "RoleDialog",
        data() {
            var roleNameMessage = (rule, value, callback) => {
                if (this.ruleForm.roleName === "") {
                    callback(new Error('Role name cannot be empty'))
                } else {
                    repeatRole({roleId: this.id, roleName: this.repeatName}).then(res => {
                        if (res.result) {
                            if (value === this.repeatName) {
                                callback(new Error("Name already exists, please redefine"));
                            }
                        } else {
                            callback();
                        }
                    })
                }


            };
            return {
                defaultArray: [],
                dialogVisible: false,
                id: "",
                repeatName: "",
                permissionIds: [],
                idsArray: [],
                ruleForm: {
                    roleName: "",
                    roleDesc: "",
                    status: "1"
                },
                rules: {
                    roleName: [{required: true, validator: roleNameMessage, trigger: "blur"}],
                    // roleDesc: [
                    //   {
                    //     required: true,
                    //     message: "Please enter a roleDesc",
                    //     trigger: "blur"
                    //   }
                    // ],
                    status: [
                        {required: true, message: "Please Role status", trigger: "change"}
                    ]
                },
                data: [],
                defaultProps: {
                    children: "childPermission",
                    label: "permissionDesc",
                    id: "id"
                },
                repeatName: "",
                permisId: [],
                newArr: [],
                length: ""
            };
        },
        created() {
            this.getTree();
        },
        methods: {
            //失去焦点
            rolenameBlur(val) {
                this.repeatName = this.ruleForm.roleName;
            },
            cancelButton() {
                this.resetForm("ruleForm");
            },
            submitForm(formName) {
                this.$refs[formName].validate(valid => {

                    if (valid) {
                        this.permissionIds = this.$refs.tree.getCheckedKeys().concat(this.$refs.tree.getHalfCheckedKeys());
                        this.$emit("submitForm", this.ruleForm, this.permissionIds);
                        this.resetForm("ruleForm");
                    } else {

                        return false;
                    }
                });
            },
            checked(id, data, newArr) {
                data.forEach(item => {
                    // this.length = item.childPermission.length
                    if (item.id == id) {
                        if (item.childPermission == null) {
                            newArr.push(item.id)
                        }
                    } else {

                        if (item.childPermission != null) {
                            this.checked(id, item.childPermission, newArr)
                        }
                    }
                })
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
                this.dialogVisible = false;
                this.$emit("visible", false, this.ruleForm);
                this.$refs.tree.setCheckedKeys([]);
                this.permissionIds = []
                this.newArr = [];
            },
            getTree() {
                permissionTree({}).then(res => {
                    this.data = res.result;
                });
            }
        },
        watch: {
            passVisible(val) {
                this.dialogVisible = val;
            },
            editId() {
                this.id = this.editId;
            },
            editMessage(val) {
                this.ruleForm.roleName = val.roleName;
                this.ruleForm.roleDesc = val.roleDesc;
                this.ruleForm.status = val.status.toString();
                this.permissionIds = val.permissionIds
                this.permissionIds.forEach(item => {
                    this.checked(item, this.data, this.newArr)
                });
                this.$nextTick(() => {
                    this.$refs.tree.setCheckedKeys(this.newArr)
                })

            },
            length() {
                this.checked()
            }
        }
    };
</script>

<style scoped>
    .role_dialog >>> .el-form-item__content .el-input__inner {
        height: 32px;
        line-height: 32px;
    }

    .role_dialog >>> .button .el-form-item__content button {
        height: 32px;
        line-height: 32px;
        padding: 0 20px;
    }

    .role_dialog >>> .el-form-item__content {
        margin-left: 120px !important;
    }

    .role_dialog >>> .el-form-item__label {
        width: 120px !important;
    }

    .role_dialog >>> .button {
        text-align: right;
        margin-bottom: 0;
    }

    .role_dialog >>> .el-dialog__body {
        padding-top: 10px;
    }

    .permission {
        height: 300px;
        border: 1px solid #dcdfe6;
        border-radius: 4px;
        overflow-y: scroll;
    }
</style>